import React, { FunctionComponent, useEffect, useState } from 'react'

import { Link } from 'react-router-dom'
import { ReactComponent as RightArrow } from '../../components/atoms/Icons/RightArrow.svg'
import { ReactComponent as On } from '../../components/atoms/Icons/switch-on.svg'
import { ReactComponent as Off } from '../../components/atoms/Icons/switch-off.svg'
import { useDispatch } from 'react-redux'
import { PageRoute } from '../../navigation/constants'

import * as S from './styled'
import useConnectRequest from '../../hooks/useConnectRequest'
import { GET_USER_BY_UID } from '../../redux/requests/auth/auth.actions'
import requestActions from '../../redux/requests/requestActions'
import { Filter } from '../../redux/requests/products/product.types'

export type UserSettings = {
  sendConfirmation?: boolean
  filters?: Filter[]
  selectedFilter?: number
}
type OwnProps = { uid: any }

type Props = OwnProps

export const Account: FunctionComponent<Props> = ({ uid }) => {
  const dispatch = useDispatch()

  const [settings, setSettings] = useState<UserSettings>({ sendConfirmation: false })

  const { loading: loadingUser, data: user } = useConnectRequest(GET_USER_BY_UID, {
    multiple: false,
  })

  useEffect(() => {
    dispatch(requestActions.auth.getUserByUid(uid))
  }, [])

  useEffect(() => {
    if (!loadingUser && user) {
      setSettings({ sendConfirmation: user.settings?.sendConfirmation })
    }
  }, [user])

  function handleClick() {
    setSettings(prev => {
      return { sendConfirmation: !prev.sendConfirmation }
    })
    dispatch(
      requestActions.auth.updateUserSettings(uid, { sendConfirmation: !settings.sendConfirmation }),
    )
  }
  return (
    <S.Container>
      <S.L0>Inställningar</S.L0>
      <S.OuterListCard>
        <S.InnerLeftListCard>
          <S.L1>Användarnamn:</S.L1>
          <S.L2>{user.name}</S.L2>
          <S.L1>Inloggnings email:</S.L1>
          <S.L2>{user.ownEmail}</S.L2>
          <S.L1>Agripare indata email:</S.L1>
          <S.L2>{user.email}</S.L2>
        </S.InnerLeftListCard>
      </S.OuterListCard>
      <S.OuterListCard>
        <S.InnerLeftListCard>
          <S.L1>Vitlistade epost-adresser</S.L1>
          <S.L2>Välj vilka epost-adresser som får skicka in data</S.L2>
        </S.InnerLeftListCard>
        <S.InnerRightListCard>
          <Link to={PageRoute.WHITELIST} style={{ textDecoration: 'none' }}>
            <RightArrow />
          </Link>
        </S.InnerRightListCard>
      </S.OuterListCard>

      <S.OuterListCard>
        <S.InnerLeftListCard>
          <S.L1>Skicka bekräftelse via epost</S.L1>

          <S.L2>
            Skicka en bekräftelse via epost när du laddar upp eller skickar in ett dokument
          </S.L2>
        </S.InnerLeftListCard>
        <S.InnerRightListCard onClick={handleClick}>
          {settings?.sendConfirmation ? <On /> : <Off />}
        </S.InnerRightListCard>
      </S.OuterListCard>
    </S.Container>
  )
}

export default Account
